import { Injectable } from '@angular/core';
// Store
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SetCurrentPhotos } from './action/photo-review.action';
// Model
import { OrderCI_PHOTOREVIEW_STATE_PATH, PhotoReviewStateModel } from './model/photo-review-state.model';
import { PhotoReviewModel } from '../model/photo-review.model';

@State<PhotoReviewStateModel>({
	name: OrderCI_PHOTOREVIEW_STATE_PATH,
	defaults: new PhotoReviewStateModel()
})
@Injectable()
export class PhotoReviewState {
	/**
	 * Get Current Photo Review Collection.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getPhotoReviewCollection(state: PhotoReviewStateModel): PhotoReviewModel[] {
		return state.currentPhotos;
	}

	/**
	 *    set the photos for the current order
	 * @param ctx
	 * @param orderId
	 */
	@Action(SetCurrentPhotos)
	setCurrentPhotos(ctx: StateContext<PhotoReviewStateModel>, { photo }: SetCurrentPhotos): any {
		ctx.patchState({
			currentPhotos: photo
		});
	}
}
